<template>
	<div class="column">
		<QuestionsHeader
			:title="$t('add_list.title')"
			:questionGroups="questionGroups"
			@change="updateQuestionGroup"
			@searchGroups="searchGroups"
		/>
		<div
			class="panel-list narrow no-hover"
			v-for="question in questions"
			:key="question.id"
		>
			<p class="panel-list-item">{{ question.name }}</p>
			<span class="icon" @click="addQuestion(question)">
				<i class="fas fa-plus"></i>
			</span>
		</div>
		<div class="panel-list narrow no-hover" v-if="questions.length == 0">
			<p class="header-item">{{ $t('add_list.no_results') }}</p>
		</div>
	</div>
</template>

<script>
import QuestionsHeader from './QuestionsHeader';
export default {
	components: {
		QuestionsHeader
	},
	props: {
		questionGroups: Array,
		questions: Array
	},
	data() {
		return {
			selectedQuestionGroup: { questions: [] }
		};
	},
	watch: {
		selectedQuestionGroup: {
			handler: function() {
				this.$emit('updateSelected', this.selectedQuestionGroup);
			}
		}
	},
	methods: {
		addQuestion(question) {
			this.$emit('addQuestion', question);
		},
		updateQuestionGroup(questionGroup) {
			this.selectedQuestionGroup = questionGroup;
		},
		searchGroups(value) {
			this.$emit('searchGroups', value);
		}
	},
	created() {
		this.selectedQuestionGroup = this.questionGroups[0];
	}
};
</script>
